module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/gems/gem-bronze-60.png"+" 60w",
        images: [{path: __webpack_public_path__ + "assets/images/gems/gem-bronze-60.png",width: 60,height: 60}],
        src: __webpack_public_path__ + "assets/images/gems/gem-bronze-60.png",
        toString: function(){return __webpack_public_path__ + "assets/images/gems/gem-bronze-60.png"},
        
        width: 60,
        height: 60
      }